module.exports = __webpack_public_path__ + "images/victor_m_preciado.jpg?v=ac537517c656da1aeef839d9902c29b3";